import React, { useEffect, useState, useContext } from "react";
import { useAuth } from "../../context/AuthContext";
import { login_zoom } from "../../api/AuthApi";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router";
import { GlobalContext } from "../../App";
import zoomSdk from "@zoom/appssdk";
import axios from "axios";
import { Spin } from "antd";

const DummyFirstPage = () => {
  const { setToastOpen, setToastMessage, setToastSeverity } =
    useContext(GlobalContext);
  const { login: authLogin } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [authCode, setAuthCode] = useState(null);
  const [loading, setLoading] = useState(true);

  const generateCodeVerifier = (length = 128) => {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode.apply(null, array))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const generateCodeChallenge = async (codeVerifier) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const handleAuth = async (code, code_verifier) => {
    try {
      setLoading(true);
      const response = await login_zoom(code, code_verifier);
      const accessToken = response.access_token || response.token;
      if (!accessToken) throw new Error("No access token received from server");
      localStorage.setItem("refresh_token", response.refresh_token);
      sessionStorage.setItem("z_user_id", response.z_user_id);
      authLogin({
        ...response,
        access_token: accessToken,
        token: accessToken,
        user_type: response.user_type,
        z_user_id: response.z_user_id,
      });

      setToastOpen(true);
      setToastSeverity("success");
      setToastMessage("Login successful!");

      switch (response.user_type) {
        case "agent":
          window.location.href = "/agent";
          break;
        case "interpreter":
          window.location.href = "/interpreter";
          break;
        default:
          break;
      }
    } catch (e) {
      console.error("Zoom login error:", e);
      setToastOpen(true);
      setToastSeverity("error");
      setToastMessage(
        e.response?.data?.message || "Login failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initAuth = async () => {
      setLoading(true);
      try {
        await zoomSdk.config({ capabilities: ["authorize", "onAuthorized"] });

        const codeVerifier = generateCodeVerifier();
        const codeChallenge = await generateCodeChallenge(codeVerifier);
        sessionStorage.setItem("code_verifier", codeVerifier);
        let authResult = await zoomSdk.authorize({
          codeChallenge,
          state: "dummy_state_123",
        });
        if (authResult.message == "Success") {
          console.log("Authorization successful!", authResult);
        }
        setLoading(false);
        zoomSdk.addEventListener("onAuthorized", async (event) => {
          console.log("onAuthorized event:", event);
          const response = await handleAuth(event.code, codeVerifier);
          console.log("Backend token exchange response:", response);
        });
      } catch (error) {
        console.error("Zoom SDK initialization error:", error);
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  // useEffect(() => {
  //   if (authCode) {
  //     handleAuth(authCode);
  //   }
  // }, [authCode]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div>{<Spin spinning={loading} fullscreen />}</div>
    </div>
  );
};

export default DummyFirstPage;
